import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';

export const AuthenticationRoute = ({
  component: Component,
  token,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      // Token can be set before the user object is loaded (Cognito JWT saved first).
      // Only redirect once we have a populated user with a resolved defaultPage.
      const isAuthenticated = Boolean(token) && !_.isEmpty(user) && Boolean(user.defaultPage);
      if (isAuthenticated) {
        const pathname = user.defaultPage;
        return (
          <Redirect
            to={{
              pathname,
            }}
          />
        );
      }
      return <Component {...props} />;
    }}
  />
);

AuthenticationRoute.propTypes = {
  location: PropTypes.object,
  component: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.node, 
      PropTypes.element, 
    ]),
  token: PropTypes.string,
  user: PropTypes.object,
};

export const mapStateToProps = (state) => {
  const user = state.getIn(['app', 'authentication', 'user'])?.toJS() || {};
  const token = state.getIn(['app', 'authentication', 'token']) || null;
  return { user, token };
};

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(AuthenticationRoute);
